import request from '@/api/request'

export default {
  async getSalesChannel () {
    return (await request.get(`module/action/marketplace/skyhub/sales_channel`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/skyhub/category/retrieveAll`)).data
  },
  async getCategoryAttributes (category) {
    return (await request.get(`module/action/marketplace/skyhub/category/retrieveAttributes/` + category)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/skyhub/index.js